import React, { useEffect } from 'react';

import ProfileCard from '@/components/Profile/ProfileHeader/ProfileCard';
import ProfileUserCard from '@/components/Profile/ProfileHeader/ProfileUserCard';
import useMediaQuery from '@/Utils/useMediaQuery';
import { useProfileNavigation } from '@/Utils/useProfileNavigation';

type Props = {
  isMobile?: boolean;
  logo: string;
};

const ProfileHeader: React.FC<Props> = ({ logo }) => {
  const isMobile = useMediaQuery('(max-width: 768px)') || false;

  const {
    cards,
    userCard,
    profileCardsExpanded,
    background,
    isUserRole,
    handleToggleCards,
    setProfileCardsExpanded,
  } = useProfileNavigation({ logo });

  useEffect(() => {
    if (isUserRole) {
      setProfileCardsExpanded(!isMobile);
    }
  }, [isMobile]);

  const showCards = isMobile ? profileCardsExpanded : isUserRole;
  const showExpandCardsButton = isMobile && isUserRole;

  return (
    <div className={`w-full ${background}`}>
      <div
        className={`media-915:grid ${isUserRole ? 'media-915:grid-cols-auto-4' : ''} media-915:gap-10 px-20 py-12 max-w-1440px mx-auto box-border`}
      >
        <ProfileUserCard
          card={userCard}
          handleToggleCards={handleToggleCards}
          profileCardsExpanded={profileCardsExpanded}
          showExpandCardsButton={showExpandCardsButton}
          isUserRole={isUserRole}
        />

        {showCards &&
          cards.map((card, index) => {
            const isFirstCard = index === 0;
            const isLastCard = index === cards.length - 1;

            return (
              <ProfileCard
                key={card.title}
                card={card}
                className={`${isFirstCard ? 'rounded-t-xl' : ''} ${
                  isLastCard ? 'rounded-b-xl' : ''
                }`}
              />
            );
          })}
      </div>
    </div>
  );
};
export default ProfileHeader;
